import { useEffect } from 'react'
import { setImage } from '../../host/Config'

const CaptureScreenshot = ({ t_id, resetCapture, video }) => {
  useEffect(() => {
    let cancelled = false

    const upload = async () => {
      if (!video || video.readyState < 2 || !t_id) return
      const width = Math.max(1, Math.floor(video.videoWidth / 3))
      const height = Math.max(1, Math.floor(video.videoHeight / 3))
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      canvas.getContext('2d').drawImage(video, 0, 0, width, height)
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.75))
      if (cancelled || !blob) return
      const formData = new FormData()
      formData.append('image', blob, 'proctoring.jpg')
      await setImage(t_id, formData)
    }

    upload().catch(() => undefined).finally(() => {
      if (!cancelled) resetCapture()
    })
    return () => { cancelled = true }
  }, [resetCapture, t_id, video])

  return null
}

export default CaptureScreenshot
